import type { ExplorationVolume } from '../../types/exploration';
import {
  accountKey,
  groupVolumesByAccount,
  sumStorage,
} from './buildClusterTopLevel';
import { buildFullHierarchy, type BuildFullHierarchyOptions, type FullHierarchyNode } from './buildFullHierarchy';

export function wrapFullHierarchyByAccount(
  volumes: ExplorationVolume[],
  opts: BuildFullHierarchyOptions
): FullHierarchyNode {
  const buckets = groupVolumesByAccount(volumes);
  const acctChildren: FullHierarchyNode[] = [];

  buckets.forEach((vols, name) => {
    const innerTree = buildFullHierarchy(vols, opts);
    acctChildren.push({
      type: 'account',
      name,
      count: vols.length,
      value: sumStorage(vols),
      children: innerTree.children,
    });
  });

  acctChildren.sort((a, b) => (b.value || 0) - (a.value || 0));

  return {
    type: 'root',
    name: 'All',
    count: volumes.length,
    value: sumStorage(volumes),
    children: acctChildren,
  };
}

export { accountKey, groupVolumesByAccount };
